<template>
    <AppErrorPage>
        <template v-slot:errorCode>
            {{ $rawText('404') }}
        </template>
        <template v-slot:errorMessage>
            {{ $t('lang_404.PAGE_NOT_FOUND') }}
        </template>
    </AppErrorPage>
</template>

<script>
import AppErrorPage from '@/app/core/components/AppErrorPage/AppErrorPage.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App404Page',
    components: { AppErrorPage },
});
</script>
